
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage';
import "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyCVQp_HT3d5YAirJbwzMkm-mta1mRAiqtQ",
  authDomain: "maatara-foundation.firebaseapp.com",
  projectId: "maatara-foundation",
  storageBucket: "maatara-foundation.firebasestorage.app",
  messagingSenderId: "655074886405",
  appId: "1:655074886405:web:876f74aca0b1c5e2106d6c",
  measurementId: "G-EH9CL03JRS"
 
};


const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;